import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
const stackItems = [{
  icon: '📖',
  title: 'EBOOK PRINCIPAL',
  value: '$197',
  description: 'Emprender con Unción: El Blueprint de +40 páginas para lanzar tu negocio en EE.UU. bajo principios bíblicos.'
}, {
  icon: '🎁',
  title: 'BONO #1',
  value: '$67',
  description: 'Plan de Negocios de 1 Página: El formato simplificado para dejar de planear y empezar a facturar en menos de 60 minutos.'
}, {
  icon: '🎁',
  title: 'BONO #2',
  value: '$47',
  description: 'IA para el Reino: Aprende a usar Inteligencia Artificial para ganar 10 horas libres a la semana.'
}, {
  icon: '🎁',
  title: 'BONO #3',
  value: '$97',
  description: 'Venta con Propósito: El guion exacto para cerrar ventas con honestidad y autoridad sin miedo a cobrar.'
}];
export function ValueStack() {
  return <section className="bg-white py-20 md:py-28 px-4" data-id="element-238">
      <div className="max-w-4xl mx-auto" data-id="element-239">
        <div className="text-center mb-16" data-id="element-240">
          <h2 className="text-3xl md:text-5xl text-navy mb-4" data-id="element-241">
            Todo lo que Recibes Hoy con tu Acceso de Fundador
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-242">
          {stackItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gray-50 border border-gray-200 p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow" data-id="element-243">
              <div className="flex items-start gap-4" data-id="element-244">
                <div className="text-4xl" data-id="element-245">{item.icon}</div>
                <div data-id="element-246">
                  <div className="flex items-center justify-between mb-2" data-id="element-247">
                    <h3 className="text-lg font-bold text-navy" data-id="element-248">
                      {item.title}
                    </h3>
                    <span className="text-sm font-semibold text-gray-500 bg-gray-200 px-2 py-1 rounded" data-id="element-249">
                      Valor {item.value}
                    </span>
                  </div>
                  <p className="text-charcoal leading-relaxed" data-id="element-250">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center bg-navy text-white p-8 md:p-12 rounded-2xl shadow-xl" data-id="element-251">
          <div className="mb-8" data-id="element-252">
            <p className="text-xl text-white/70 mb-2" data-id="element-253">
              VALOR TOTAL: <span className="line-through" data-id="element-254">$408</span>
            </p>
            <p className="text-3xl md:text-4xl font-bold text-gold" data-id="element-255">
              TÚ PAGAS HOY SOLO: $6.36
            </p>
          </div>

          <Button onClick={() => document.getElementById('pricing-cta')?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })} className="w-full md:w-auto text-lg md:text-xl" data-id="element-256">
            ✅ QUIERO TODO ESTO POR $6.36 — DESCARGAR AHORA
          </Button>
        </div>
      </div>
    </section>;
}